import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {gql, useLazyQuery} from "@apollo/client/index";
import Alert from "@material-ui/lab/Alert/Alert";
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Grid from "@material-ui/core/Grid/Grid";
import LinearProgress from "@material-ui/core/LinearProgress/LinearProgress";
import ContactsForm from "./ContactsForm";

const useStyles = makeStyles((theme) => ({
    root: {

    },
    progress: {
        marginTop: -4
    },
    handle: {
        borderTop: '1px dashed #ccc'
    },
    section: {
        width: '100%'
    },
    button: {
        marginTop: 5
    },
    fullWidth: {
        width: '100%'
    }
}));

const SEND_CONTACT_INFORMATION = gql`
  query($requestCode: String, $updateHash: String, $contactInformationInput: ContactInformationInput) {
    sendContactInformation(requestCode: $requestCode, updateHash: $updateHash,
        contactInformationInput: $contactInformationInput) {
        message
    }
  }
`;

export default function ProvideContactInformationAction(props) {

    const classes = useStyles();
    const [sent, setSent] = React.useState();

    let [sendContactInformation, {loading, data, error}]
        = useLazyQuery(SEND_CONTACT_INFORMATION);

    if (!loading && data) {
        data = null;
        props.onActionComplete();
    }

    const handleContactInformation = (values) => {
        sendContactInformation({variables: {
                requestCode: props.request.code,
                updateHash: props.request.updateHash,
                contactInformationInput: values
            }})
    };

    return (
        <div className={classes.root}>
            <Accordion>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                >
                    <Typography className={classes.heading}>Your contact information</Typography>
                </AccordionSummary>
                <AccordionDetails className={classes.handle}>
                    <Grid className={classes.fullWidth}>
                        {sent ? <Grid item><Alert className={classes.fullWidth} severity={"success"}>Contact Information is sent to Dealer</Alert><p></p></Grid> : ''}

                        {error ? <Grid item><Alert className={classes.fullWidth} severity={"error"}>{error.message}</Alert><p></p></Grid> : ''}

                        <Grid item>
                    <div className={classes.section}>
                        <ContactsForm handleContactInformation={handleContactInformation} loading={loading}/>
                    </div>
                        </Grid>
                        {loading && !error ? <Grid item><LinearProgress className={classes.fullWidth} /></Grid> : ''}
                    </Grid>
                </AccordionDetails>
            </Accordion>
        </div>
    );
}